import React from 'react';
import FilterButton from './Button';
import FilterModal from './Modal';
import useControlCommonItemOpen from '../../../hook/Common/Open/useControlCommonFilterOpen';

const CommonFilter = ({ filters, onSave, open, setOpen, ...props }) => {
  const { buttonRef, modalRef } = useControlCommonItemOpen({ open, setOpen });

  /** Rendering */
  return (
    <div className="relative">
      <FilterButton ref={buttonRef} setOpen={setOpen} />

      {/* Display modal only when open is true */}
      {open && (
        <FilterModal
          ref={modalRef}
          filters={filters}
          setOpen={setOpen}
          onSave={onSave}
          {...props}
        />
      )}
    </div>
  );
};

export default CommonFilter;
